export default __webpack_public_path__ + "static/media/imageLogisticsContentOne.bde8f5b6.png";